import React from 'react';

import Image from 'next/image';

import { routes } from '@routes';

import { link } from '@utils/link';
import { messageIdConcat } from '@utils/message-id-concat';

import { Link, Text, Row, Col, H6 } from '@atoms';

import classes from './footer-company.module.scss';

const m = messageIdConcat('footer');

export const CompanyDesktop = () => {
  return (
    <div className={classes.desktopRow}>
      {/* LOGO */}
      <Link {...link(routes.homepage)}>
        <div className={classes.reasLogo}>
          <Image
            src={require('@public/static/img/logo.svg')}
            alt="logo"
            width={135}
            height={36}
            unoptimized
          />
        </div>
      </Link>
      {/* COMPANY INFO */}
      <Text
        type="reduced"
        message={{ id: 'footer.company_info' }}
        color="slate_gray"
      />
      <Link
        className={classes.facebook}
        href="https://www.facebook.com/reas.cz"
        external
        newTab
      >
        <H6
          message={{ id: m('links.facebook') }}
          color="azure_radiance"
          margin={0}
        />
        <Image
          src={require('@public/static/img/facebook-logo.svg')}
          alt="facebookLogo"
          width={40}
          height={40}
          unoptimized
        />
      </Link>
    </div>
  );
};

export const CompanyMobile = () => {
  return (
    <div className={classes.mobileRow}>
      <Link
        className={classes.facebook}
        href="https://www.facebook.com/reas.cz"
        external
        newTab
      >
        <H6
          message={{ id: m('links.facebook') }}
          color="azure_radiance"
          margin={0}
        />
        <Image
          src={require('@public/static/img/facebook-logo.svg')}
          alt="facebookLogo"
          width={40}
          height={40}
          unoptimized
        />
      </Link>
      <div className={classes.divider} />
      <Row className={classes.companyRow}>
        {/* LOGO */}
        <Col className={classes.logoCol}>
          <Link {...link(routes.homepage)}>
            <div className={classes.reasLogo}>
              <Image
                src={require('@public/static/img/logo-no-text.svg')}
                alt="logo"
                width={57}
                height={57}
                unoptimized
              />
            </div>
          </Link>
        </Col>

        <Col className={classes.adressCol}>
          {/* COMPANY INFO */}
          <Text
            type="reduced"
            message={{ id: 'footer.company_info' }}
            color="slate_gray"
          />
        </Col>
      </Row>
      <div className={classes.divider} />
    </div>
  );
};
